import { useEffect } from 'react';
import { unwrapResult } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import { CustomButton, CustomTable } from '../../../../shared/uiComponents';
import { errorNormalizer } from '../../../../shared/Helpers/functions';
import SearchBar from '../../../../components/SearchBar';
import { ReportFilters, downloadFile } from '../../../Reports/helpers';
import { DSUSoapNoteFilters, Headers, TableBody } from './tableInfo';

import { DispatchProperties, useSelector } from '../../../../redux/store';
import { downloadDSUSoapNotes, getDSUSoapNotes } from '../../../../redux/State/clientSlice/soapNoteSlice';
import { GetDSUSoapNotesProperties } from '../../../../redux/API/ClientAPIHelpers/soapNoteProperties';

const DSUNotes = () => {
	const dispatch = useDispatch<DispatchProperties>();
	const [params] = useSearchParams();

	const notes = useSelector((state) => state.soapNote.dsuSoapNotes);
	const loading = useSelector((state) => state.soapNote.loading);
	const { clientId, endDate, startDate, userId } = useSelector((state) => state.billing.billingFilters);
	const bcbaNoteStatuses = useSelector((state) => state.soapNote.bcbaStatuses);
	const btNoteStatuses = useSelector((state) => state.soapNote.btStatuses);

	const page = params.get('page') || '1';
	const pageSize = params.get('pageSize') || '8';
	const direction = params.get('direction') || '';
	const orderBy = params.get('orderBy') || '';
	const searchString = params.get('searchString') || '';
	const pageSizeTotal = notes.totalNumberOfItems ? notes.totalNumberOfItems.toString() : '8';

	useEffect(() => {
		if (!startDate || !endDate) return;
		const data: GetDSUSoapNotesProperties = {
			page,
			pageSize,
			startDate,
			endDate,
			direction,
			orderBy,
			searchString,
			userId,
			clientId,
			status: bcbaNoteStatuses,
			supervisedStatus: btNoteStatuses,
		};

		dispatch(getDSUSoapNotes(data)).then(unwrapResult).catch(errorNormalizer);
	}, [
		dispatch,
		page,
		pageSize,
		startDate,
		endDate,
		direction,
		orderBy,
		searchString,
		userId,
		clientId,
		bcbaNoteStatuses,
		btNoteStatuses,
	]);

	const donwloadDSUNotesHandler = () => {
		if (!startDate || !endDate) return;
		const data: GetDSUSoapNotesProperties = {
			page,
			pageSize: pageSizeTotal,
			startDate,
			endDate,
			direction,
			orderBy,
			searchString,
			userId,
			clientId,
			status: bcbaNoteStatuses,
			supervisedStatus: btNoteStatuses,
		};

		dispatch(downloadDSUSoapNotes(data))
			.then(unwrapResult)
			.then((response) => downloadFile(response))
			.catch(errorNormalizer);
	};

	return (
		<>
			<ReportFilters showUsers showShorcuts={false} />
			<div
				style={{
					display: 'flex',
					gap: '16px',
					alignItems: 'center',
					marginBottom: '16px',
				}}
			>
				<CustomButton
					onClick={donwloadDSUNotesHandler}
					title="Download"
					loading={loading}
					style={{ marginTop: '8px' }}
				/>
				<SearchBar hasFilter style={{ marginTop: '8px' }} />
				<DSUSoapNoteFilters />
			</div>
			<CustomTable headers={Headers} TableBody={TableBody} data={notes} loading={loading} hasMobile={false} />
		</>
	);
};

export default DSUNotes;
